/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

// Import Routes

import { Route as rootRoute } from "./routes/__root"
import { Route as IndexImport } from "./routes/index"
import { Route as PayrollIndexImport } from "./routes/payroll/index"

// Create/Update Routes

const IndexRoute = IndexImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => rootRoute,
} as any)

const PayrollIndexRoute = PayrollIndexImport.update({
  id: "/payroll/",
  path: "/payroll/",
  getParentRoute: () => rootRoute,
} as any)

// Populate the FileRoutesByPath interface

declare module "@tanstack/react-router" {
  interface FileRoutesByPath {
    "/": {
      id: "/"
      path: "/"
      fullPath: "/"
      preLoaderRoute: typeof IndexImport
      parentRoute: typeof rootRoute
    }
    "/payroll/": {
      id: "/payroll/"
      path: "/payroll"
      fullPath: "/payroll"
      preLoaderRoute: typeof PayrollIndexImport
      parentRoute: typeof rootRoute
    }
  }
}

// Create and export the route tree

export interface FileRoutesByFullPath {
  "/": typeof IndexRoute
  "/payroll": typeof PayrollIndexRoute
}

export interface FileRoutesByTo {
  "/": typeof IndexRoute
  "/payroll": typeof PayrollIndexRoute
}

export interface FileRoutesById {
  __root__: typeof rootRoute
  "/": typeof IndexRoute
  "/payroll/": typeof PayrollIndexRoute
}

export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths: "/" | "/payroll"
  fileRoutesByTo: FileRoutesByTo
  to: "/" | "/payroll"
  id: "__root__" | "/" | "/payroll/"
  fileRoutesById: FileRoutesById
}

export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  PayrollIndexRoute: typeof PayrollIndexRoute
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  PayrollIndexRoute: PayrollIndexRoute,
}

export const routeTree = rootRoute
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()

/* ROUTE_MANIFEST_START
{
  "routes": {
    "__root__": {
      "filePath": "__root.tsx",
      "children": [
        "/",
        "/payroll/"
      ]
    },
    "/": {
      "filePath": "index.tsx"
    },
    "/payroll/": {
      "filePath": "payroll/index.tsx"
    }
  }
}
ROUTE_MANIFEST_END */
